module.exports = __webpack_public_path__ + "media/images/flags/16/Sierra-Leone-bc40f00c24b37e104d749b053dec2949.png";